import { FaqPage as FaqPageComponent } from './FaqPage';

export const FaqPage = FaqPageComponent;
